import { FC, HTMLProps, ReactNode } from 'react';

import { ImageFitVariant, ImagePosition } from './model';
import { Body, Card, Extra, Image, Main, Title } from './ReadOnlyCard.styles';

type Inherited = Omit<HTMLProps<HTMLDivElement>, 'title'>;

interface Props extends Inherited {
    imagePosition?: ImagePosition;
    imageFit?: ImageFitVariant;
    image?: { src: string; altText: string };
    title: ReactNode;
    body?: ReactNode;
    children?: ReactNode;
    'data-test'?: string;
}

export const ReadOnlyCard: FC<Props> = ({
    id,
    title,
    body,
    children,
    image,
    imagePosition = 'right',
    imageFit = 'outset',
    'data-test': dataTest = 'checkbox-card',
    ...inherited
}) => {
    const TEST_ID = { IMAGE: `${dataTest}--image` };

    return (
        <Card {...inherited} $imagePosition={imagePosition}>
            {!!image && (
                <Image
                    src={image.src}
                    alt={image.altText}
                    $imageFit={imageFit}
                    $imagePosition={imagePosition}
                    data-test={TEST_ID.IMAGE}
                />
            )}
            <Main $imagePosition={imagePosition}>
                {typeof title === 'string' ? <Title>{title}</Title> : title}
                {typeof body === 'string' ? <Body>{body}</Body> : body}
            </Main>
            {!!children && <Extra>{children}</Extra>}
        </Card>
    );
};
